import React from "react";
import Footer from "../Components/Footers/Footer";
import "../assests/css/AboutUs.css";
import Header from "../Components/Headers/Header";
import { Link } from "react-router-dom";

const AboutUs = () => {
  const handleBooking = () => {
    // window.location.replace("https://eb3.autocab.net/#/33710");
    window.open("https://eb3.autocab.net/#/33710", "_blank");
  };
  return (
    <div className="aboutus">
      <section className="bg-privacy-policy-top mb-3">
        <Header />
        <div className="container px-5">
          <div className="row px-3">
            <div className="col-lg-12 my-4 text-center">
              <p className="text-white f-72 my-5 f-pop-med">About Us</p>
            </div>
          </div>
        </div>
      </section>
      <section className="first_sec mt-5">
        <div className="container my-5">
          <div className="row my-5">
            <div className="col-lg-6 ">
              <p className="color_red f-20 f-pop-med">About Us</p>
              <p className="color_1c f-25 f-pop-med">
                Trusted Taxi Services in Stanfed Airport
              </p>
              <p className="color_c0 f-14 f-pop-med mt-4 ">
                The time changes, but one thing that does not change is our
                service. We are one of the leading airport taxi transfer
                services in the United Kingdom. Metro 24 x 7 is a reliable
                Stansted airport taxi transfer service that offers the highest
                possible services to clients. We were formed to cater to the
                needs of clients that are looking for convenient taxi transfers
                throughout the UK from or to Stansted airport. Metro 24 x 7 was
                established in 1987 at Harlow’s HQ. Additionally, all our
                personnel, including customer service agents, are totally
                devoted to assisting you. Metro 24 x 7 does not have any hidden
                charges for clients, and only the amount that is quoted will be
                charged from our customers.
              </p>
            </div>
            <div className="col-lg-6 ">
              <div className="bg-img-merctop"></div>
            </div>
            <div className="col-lg-4">
              <p className="color_1c f-25 f-pop-med mt-3">Our Mission</p>
              <p className="color_c0 f-14 f-pop-med mt-3 ">
                Our mission is to provide the highest quality service and trust
                worthy services to customers while maintaining all the ethical
                and best practice standards.
              </p>
            </div>
            <div className="col-lg-4">
              <p className="color_1c f-25 f-pop-med mt-3">Our Vision</p>
              <p className="color_c0 f-14 f-pop-med mt-3 ">
                To become a national taxi service that is comfortable,
                convenient, and safe for all travelers.
              </p>
            </div>
            <div className="col-lg-4">
              <p className="color_1c f-25 f-pop-med mt-3">Our Values</p>
              <p className="color_c0 f-14 f-pop-med mt-3 ">
                We do not violate any kind of national or international law and
                do not support any type of racism or sexism.
              </p>
            </div>
            <div className="col-lg-12">
              {/* <Link to="/booking" className='link_ourfleet'>
                                <button className='btn btn-danger bt-aboutus f-14 f-pop-med mt-5'>Book Now</button>
                            </Link> */}
              <a className="link_ourfleet">
                <button
                  className="btn btn-danger bt-aboutus f-14 f-pop-med mt-5"
                  onClick={handleBooking}
                >
                  Book Now
                </button>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="mt-cus-aboutus">
        <div className="bg_red_cont">
          <div className="container ">
            <div className="row">
              <div className="col-lg-6 ">
                <div className="bg_taxi_driver"></div>
              </div>
              <div className="col-lg-6 my-5 ">
                <div className="our_service_about">
                  <p className="f-pop-med f-25 text-white mb-4">Our Services</p>
                  <p className="f-pop-med f-14 text-white lh-02">
                    If you are looking to go to Stansted airport or you want
                    service from Stansted airport to your residence or any other
                    location, we are here to assist you. Currently, our fleet of
                    vehicles consists of Skoda Superb Estate, Mercedes C Class,
                    Ford Galaxy, and Mercedes Vito. Depending on your need for
                    people and luggage we offer different types of taxis. We
                    assure you that our Stansted airport private hire taxi would
                    be driven by DBS checked, skilled, experienced, and
                    competent drivers only. Your safety and comfort are our only
                    mission and concern.
                  </p>
                  {/* <Link to="/booking" className="link_ourfleet">
                    <button className="btn btn-danger bt-aboutus f-14 f-pop-med mt-5">
                      Book Now
                    </button>
                  </Link> */}
                  <a className="link_ourfleet">
                    <button
                      className="btn btn-danger bt-aboutus f-14 f-pop-med mt-5"
                      onClick={handleBooking}
                    >
                      Book Now
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-white-toomanymerce">
        <div className="container ">
          <div className="row">
            <div className="col-lg-6 py-5">
              <div className="py-5">
                <p className="color_1c f-25 f-pop-med">Our Vehicles</p>
                <p className="color_c0 f-14 f-pop-med mt-4 lh-02">
                  What are your requirements? Just contact our representative,
                  and our staff will guide you through the whole process. We
                  have regularly maintained 4 seaters, Skoda Superb Estate,
                  Mercedes C Class, 6 seaters, Ford Galaxy, and 8 seaters,
                  Mercedes Vito.
                </p>
                <Link to="/ourfleet" className="link_ourfleet">
                  <button className="btn btn-danger bt-aboutus f-14 f-pop-med mt-5">
                    Explore Vehicles
                  </button>
                </Link>
              </div>
            </div>
            <div className="col-lg-6 py-5">
              <div className="mercedes_many"></div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg_red_cont pos-rel">
        <div className="container ">
          <div className="row ">
            <div className="col-lg-6">
              <div className="bg-van-btm"></div>
            </div>
            <div className="col-lg-6 py-5 text-end">
              <p className="f-45 f-pop-semibold text-white mb-3 mt-5">
                Book A Cab Online
              </p>
              <p className="f-14 f-pop-reg text-white lh-02">
                Curabitur placerat cursus nisi nec pharetra. Proin quis tortor
                fringilla, placerat nisi nec, auctor ex. Donec commodo orci ac
                lectus mattis
              </p>
              <Link to="/booking" className="link_ourfleet">
                <button className="btn btn-danger f-14 bt-aboutus clr-white-btn-book f-pop-med mt-3 mb-5">
                  Book now
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default AboutUs;
